import React from 'react';

export default class PumpAdditionalFilters extends React.Component {
    getLabel = () => this.props.visible ? 'Hide filters' : 'Show filters';

    canRender = () => [this.props.fields.singleTwin, this.props.fields.adjustable, this.props.fields.dryMotor, this.props.fields.powerSupply, this.props.fields.pumpDPE].some(x => x && x.visible);

    render() {
        if (!this.canRender()) {
            return <React.Fragment/>
        }

        return (
            <div className="additional-filters-container">
                <span className="additional-filters-label"
                      onClick={this.props.onVisibleClick}>{__(this.getLabel())}</span>
                {this.props.visible && (
                    <div>
                        {this.props.renderGenericHorizontalField(this.props.fields.singleTwin, {className: 'pump-additional-filter'})}
                        {this.props.renderGenericHorizontalField(this.props.fields.adjustable, {className: 'pump-additional-filter'})}
                        {this.props.renderGenericHorizontalField(this.props.fields.dryMotor, {className: 'pump-additional-filter'})}
                        {this.props.renderGenericHorizontalField(this.props.fields.powerSupply, {className: 'pump-additional-filter'})}
                        {this.props.renderGenericHorizontalField(this.props.fields.pumpDPE, {className: 'pump-additional-filter'})}
                    </div>)}
            </div>
        )
    }
}